import { Injectable } from "@angular/core";
import { ModalComponent } from "../../components/layout/modal/modal.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap/modal/modal-ref";
import {Observable, Subject} from 'rxjs';
const modalOptions: NgbModalOptions = {
  backdrop: "static",
  keyboard: false,
  windowClass: "" //todo
};

@Injectable()
export class ModalService {
  isOpen: boolean;
  modalRef: NgbModalRef;
  windowClass: any;
  allModalControlsGenerated: Subject<void> = new Subject<void>();
  allModalControlsGenerated$: Observable<void> = this.allModalControlsGenerated.asObservable();

  constructor(private modalService: NgbModal) {}

  async open({ data: data, windowClass: windowClass }) {
    if (this.isOpen) {
      return;
    }
    modalOptions.windowClass = windowClass;
    const modalRef: NgbModalRef = this.modalService.open(
      ModalComponent,
      modalOptions
    );
    this.modalRef = modalRef;
    this.isOpen = true;
    modalRef.componentInstance.modal = { data };
    modalRef.componentInstance.closeModal = this.close;
    modalRef.componentInstance.modalRef = this.modalRef;
    await modalRef.result;
    this.isOpen = false;
  }

  async close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

}
